import axios from "axios";

// const Base_Url = "http://localhost:5000/";
const Base_Url = "https://timeshoppy.onrender.com/";
export const PublicRequest = axios.create({
  baseURL: Base_Url,
});

export const UserRequest = (token) => {
  return axios.create({
    baseURL: Base_Url,
    headers: {
      token: `Bearer ${token}`,
    },
  });
};

export const getUserRequestWithToken = (token) => {
  return axios.create({
    baseURL: Base_Url,
    headers: {
      token: `Bearer ${token}`,
    },
  });
};
